import React from "react";


function Portfolio() {
    return (
        <>
            <div id="portfolio">
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/1.jpg"
                               title="CRM & ERP">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/1.jpg" alt="..."/>
                                <div className="portfolio-box-caption">
                                    <div className="project-category text-white-50">CRM & ERP</div>
                                    <div className="project-name">Personel/Müşteri Yönetim Paneli</div>
                                </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/2.jpg"
                               title="Sağlık">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/2.jpg" alt="..."/>
                                <div className="portfolio-box-caption">
                                    <div className="project-category text-white-50">Sağlık</div>
                                    <div className="project-name">Doktor Randevu Sistemi </div>
                                </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/3.jpg"
                               title="Sağlı">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/3.jpg" alt="..."/>
                                <div className="portfolio-box-caption">
                                    <div className="project-category text-white-50">Sağlık</div>
                                    <div className="project-name">Diyetisyen / Beslenme Uzmanı</div>
                                </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/4.png"
                               title="E-Ticaret">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/4.jpg" alt="..."/>
                                <div className="portfolio-box-caption">
                                    <div className="project-category text-white-50">E-Ticaret</div>
                                    <div className="project-name">Kuyumcu Online Satış Sitesi</div>
                                </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/5.png"
                               title="Eğitim">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/5.jpg" alt="..."/>
                                <div className="portfolio-box-caption">
                                    <div className="project-category text-white-50">Eğitim</div>
                                    <div className="project-name">Eğitim Portali</div>
                                </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <a className="portfolio-box" href="/assets/img/portfolio/fullsize/6.png"
                               title="Hukuk">
                                <img className="img-fluid" src="/assets/img/portfolio/thumbnails/6.jpg" alt="..."/>
                                <div className="portfolio-box-caption p-3">
                                    <div className="project-category text-white-50">Hukuk</div>
                                    <div className="project-name">Hukuk Bürosu</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Portfolio;